import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
export var getIsRobot = function() {
    var _getGlobalProperty;
    return isPrerender() || ((_getGlobalProperty = getGlobalProperty("isRobot", false)) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : false);
};
